import { Component,h, Prop } from '@stencil/core';

@Component({
  tag: 'delete-icon',
  shadow: false
})
export class DeleteIcon {
  @Prop() svgStyle: any = {};
  @Prop() width: number = 14;
  @Prop() height: number = 14;

  render() {
    return (
      <svg
        style={this.svgStyle}
        width={this.width}
        height={this.height}
        viewBox="0 0 24 24"
      >
        <slot />
        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
        <path d="M0 0h24v24H0z" fill="none" />
      </svg>
    );
  }
}
